import {
  FETCH_PAGE_CONTENT,
  FETCH_PAGE_CONTENT_FULFILLED,
  FETCH_PAGE_CONTENT_REJECTED,
  FETCH_PAGE_PROMO_CONTENT,
  FETCH_PAGE_PROMO_CONTENT_FULFILLED,
  FETCH_PAGE_PROMO_CONTENT_REJECTED,
  SAVE_LIVE_CHAT_STATUS,
  SET_CHAT_MINIMIZED,
  SET_CHAT_ENDED,
  TOGGLE_CHAT
} from '../actions/types'

export default function reducer (state = {
  page: null,
  pageLoading: false,
  pageError: false,
  promos: null,
  promosLoading: false,
  promosError: false,
  chatLoading: true,
  chatOnline: true,
  chatOpeningHours: null,
  chatIsMinimized: false,
  chatHasEnded: null,
  chatReset: false
}, action) {
  switch (action.type) {
    case FETCH_PAGE_CONTENT: {
      return { ...state, pageLoading: true, pageError: false }
    }
    case FETCH_PAGE_CONTENT_FULFILLED: {
      return { ...state, page: action.payload, pageLoading: false }
    }
    case FETCH_PAGE_CONTENT_REJECTED: {
      return { ...state, pageLoading: false, pageError: true }
    }
    case FETCH_PAGE_PROMO_CONTENT: {
      return { ...state, promosLoading: true, promosError: false }
    }
    case FETCH_PAGE_PROMO_CONTENT_FULFILLED: {
      return { ...state, promos: action.payload, promosLoading: false }
    }
    case FETCH_PAGE_PROMO_CONTENT_REJECTED: {
      return { ...state, promosLoading: false, promosError: true }
    }
    case SAVE_LIVE_CHAT_STATUS: {
      return {
        ...state,
        chatLoading: false,
        chatOnline: action.payload.online,
        chatOpeningHours: action.payload.openingHours,
        chatError: action.payload.error
      }
    }
    case SET_CHAT_MINIMIZED: {
      return { ...state, ...action.payload }
    }
    case SET_CHAT_ENDED: {
      return { ...state, ...action.payload }
    }
    case TOGGLE_CHAT: {
      return { ...state, ...action.payload }
    }
    default:
      return state
  }
}
